import { useEffect } from "react";
import { Crisp } from "crisp-sdk-web";

const CRISP_WEBSITE_ID = "db654ae6-f54d-4afd-aed9-0ce268d583a2";

export function CrispChat() {
  useEffect(() => {
    // Only run on client side
    if (typeof window === "undefined") return;

    console.log("[CrispChat] Initializing Crisp SDK...");

    try {
      // Configure Crisp with website ID
      Crisp.configure(CRISP_WEBSITE_ID);
      console.log("[CrispChat] Crisp configured with website ID:", CRISP_WEBSITE_ID);

      // Load the chatbox
      Crisp.load();
      console.log("[CrispChat] Crisp chatbox loaded");

      // Optional: Set user information if available
      // You can uncomment and customize these based on your auth context
      // const userEmail = getCurrentUserEmail();
      // if (userEmail) {
      //   Crisp.user.setEmail(userEmail);
      //   Crisp.user.setNickname(userDisplayName);
      // }
    } catch (error) {
      console.error("[CrispChat] Failed to initialize Crisp:", error);
    }
  }, []);

  return null;
}